// Utils
import { prefixObjectId } from './prefixObjectId';
import { getUniqueId } from './getUniqueId';
import { getPrimaryObjectIdGenerator } from './getPrimaryObjectIdGenerator';
/**
 * Generates an object identifier, potentially using a reference to identify objects as part of
 * another record.
 *
 * @param {any} object
 * @param {string|null} pathRelativeToParentObject
 */
export var generateObjectId = function (object, pathRelativeToParentObject) {
    if (pathRelativeToParentObject === void 0) { pathRelativeToParentObject = null; }
    var identity = null;
    var identityGenerator = getPrimaryObjectIdGenerator();
    if (identityGenerator !== null) {
        identity = identityGenerator(object);
    }
    if (identity === null) {
        identity = getUniqueId();
        if (pathRelativeToParentObject !== null) {
            identity = pathRelativeToParentObject + "_" + identity;
        }
    }
    return prefixObjectId(identity);
};
//# sourceMappingURL=generateObjectId.js.map